import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

type Instruction = server.dto.ListHubSpotContactInstruction & { page: number, perPage: number };

const HubSpotContactList = (props: PickerListProps<server.dto.HubSpotContact>) => {
  const [instruction, setInstruction] = React.useState<Instruction>({
    keyword: "",
    // Dummy properties to satisfy the type
    page: 1,
    perPage: 10
  });

  return <>
    <PickerList<server.dto.HubSpotContact, number | string, Instruction>
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="hubspotList"
      api={window.CoreApi.HubSpot.SearchContacts}
      onClick={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={c => c.id}
      renderListItem={hsContact => <div className="flex gap">
        <div className="grow1">
          <div>{hsContact.name.fullName}</div>
          <div className="text-sublabel">{hsContact.lifecycleStageLabel}</div>
        </div>
      </div>
      }
    />
  </>;
};

export default HubSpotContactList;